import type { AssignmentType } from '../../model/domain/enum/AssignmentType';
import type { CategoryType } from '../../model/domain/enum/CategoryType';
import type { DeckType } from '../../model/domain/enum/DeckType';
import type { CycleMode, StudyCard, StudyCardMedia } from '../../model/domain/StudySession';
import type { StudyCardTO } from '../to/StudySessionTO';

const toDomain = (to: StudyCardTO): StudyCard => ({
  guid: to.guid,
  answer: to.answer,
  explanation: to.explanation,
  answers: to.answers,
  question: to.question,
  incorrectAnswers: to.incorrectAnswers,
  assignmentCreatedOn: to.assignmentCreatedOn,
  assignmentType: to.assignmentType as AssignmentType,
  category: to.category as CategoryType,
  deckName: to.deckName,
  deckType: to.deckType as DeckType,
  due: to.due,
  feedback: to.feedback,
  laps: to.laps,
  cycle: to.cycle as CycleMode,
  media: to.media as StudyCardMedia[] | null,
});

export default {
  toDomain,
};
